import { Component, Input, OnChanges, SimpleChanges, ChangeDetectionStrategy } from "@angular/core";

import { CacheService } from './../../../../services/sys/cache.service';

declare var jQuery: any;

@Component({
    selector: "cmn-message",
    templateUrl: "cmn-message.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class CmnMessageComponent implements OnChanges {
    @Input() cmsgFieldId: string;
    @Input() cmsgLinkText: string;
    @Input() cmsgHelpFile: string;
    @Input() cmsgShowHelp: boolean = false;
    @Input() cmnHidden: boolean;
    @Input() cmsgSkipFocusOnVisibilityChange: boolean = false;
    @Input() cmsgHelpUseLocalFile: boolean = false;
    @Input() cmsgHelpLocalFilePath: string;
    
    iconText: string;

    constructor(private cacheService: CacheService) { }
    
    ngOnInit() {

    }
  
    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (changes.hasOwnProperty(propName)) {
                const change = changes[propName];
                const currentValue = JSON.stringify(change.currentValue);
                const previousValue = JSON.stringify(change.previousValue);
                if ((propName === 'cmnHidden') && (currentValue === 'false') && (this.cmsgSkipFocusOnVisibilityChange == false)) {
                    setTimeout(() => {
                        jQuery('.pageTransitionWrap').find('a#showOrderButtonsLink0, a#hideOrderButtonsLink0, button, .error, .info.userHasNotSeenMessage, .saved, input:enabled, select:enabled, ngb-accordion a, .agreement').first().focus();
                    }, 100);
                }
            }
        }
    }
	
	onTabKey(event) {
		if(jQuery(event.target).hasClass('userHasNotSeenMessage')) {
			jQuery(event.target).removeClass('userHasNotSeenMessage');
			jQuery(event.target).addClass('userHasSeenMessage');
		}
	}
}